import CardDefault from "components/Cards/CardDefault";
import { Flex, Divider } from "@chakra-ui/react";
import ActionsKebabMenu from "ui/components/ActionsKebabMenu";
import DescricaoConta from "./../DescricaoConta/index";
import ContentTags from "./../ContentTags/index";
import { PrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import { MdEdit, MdDelete } from "react-icons/md";
import history from "infra/helpers/history";

interface ItemPrevisaoOrcamentariaProps {
  item: PrevisaoOrcamentaria;
  handleDelete: (id: string) => Promise<void>;
  setPrevisaoDto: (item: PrevisaoOrcamentaria | undefined) => void;
  onEdit: (id: string) => void;
  refetch: any;
}

export default function ItemPrevisaoOrcamentaria({
  item,
  handleDelete,
  onEdit,
  setPrevisaoDto,
  refetch,
}: ItemPrevisaoOrcamentariaProps) {
  return (
    <CardDefault
      mb={6}
      px={6}
      py={4}
      onClick={() =>
        history.push(`/financeiro/previsao-orcamentaria/${item.id}`)
      }
    >
      <Flex flexDir="column">
        <Flex>
          <Flex w="100%">
            <DescricaoConta item={item} />
          </Flex>
          <Flex h="fit-content">
            <ActionsKebabMenu
              indexItem={2}
              item={item}
              actions={[
                {
                  title: "Editar",
                  icon: () => <MdEdit />,
                  onClick: (v) => {
                    onEdit(v.id);
                    setPrevisaoDto(v);
                  },
                },
                {
                  title: "Excluir",
                  icon: () => <MdDelete />,

                  onClick: (v) => {
                    handleDelete(v.id);
                  },
                },
              ]}
            />
          </Flex>
        </Flex>
        {item.valorArrecadacao ? (
          <>
            <Divider my={4} />
            <ContentTags item={item} />
          </>
        ) : null}
      </Flex>
    </CardDefault>
  );
}
